const BulletinBanner = () => {
    return (
        <div className='flex flex-col justify-center items-center w-full lg:h-64 md:auto h-auto text-white gap-5 bg-[#202020] py-5'>
            <h1 className='md:text-4xl text-2xl tracking-[0.5rem] text-center'>Welcome To Our Bulletin!</h1>
            <p className='md:text-2xl text-xl px-10 text-center'>
                Welcome to the official News and Bulletin page of ProSynergy Inc. Here, we keep you informed about the latest company updates, industry insights, milestones, and important announcements. Whether it's our newest partnerships, service innovations, or corporate initiatives, this space serves as your go-to source for everything happening at ProSynergy.
            </p>
        </div>
    )
}

export default BulletinBanner
